export default __webpack_public_path__ + "media/trail/icons-controls-zoom-out-bd2c8b11.svg";